import * as NavConstants from 'constants/NavConstants';
import FolderDAO from 'file-browser/FolderDAO';
import normalizeFolder from 'folders/util/normalizeFolder';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import notifications from 'notifications';
import {getStore} from 'redux-stores/Store';
import {getFilterByKey} from 'search/FilterUtil';
import {
  convertFromGraphqlSavedSearchParams,
  NonPaginatedSearchParams,
  SavedSearch,
} from 'search/saved-searches/SavedSearchUtil';
import {FilterKey} from 'search/SearchConstants';

export async function switchToSavedSearchProjectFolder(savedSearch?: SavedSearch): Promise<void> {
  // If we are trying to unload a saved search, we don't need to do anything special, so simply return.
  if (!savedSearch) {
    return;
  }

  const searchParams = convertFromGraphqlSavedSearchParams(savedSearch.searchParams);
  await switchToSavedSearchProjectFolderWithParams(searchParams);
}

export async function switchToSavedSearchProjectFolderWithParams(
  searchParams: NonPaginatedSearchParams,
  forceOpen: boolean = false
): Promise<void> {
  const folderFilter =
    getFilterByKey(searchParams.filters, FilterKey.FOLDER) ??
    getFilterByKey(searchParams.filters, FilterKey.ANCESTOR_FOLDER);
  if (!folderFilter) {
    throw new Error('No folder filter specified for projects listing saved search.');
  }

  const currentListedFolder = SidepanelStore.getListedFolder(NavConstants.Section.PROJECT_ITEMS);
  const currentSection = SidepanelStore.getSection();
  // If the saved search is for a different project, or we are currently not in the PROJECT_ITEMS section, we
  // need to switch to the correct project in the PROEJCT_ITEMS listing before loading the saved search.

  // For saved search purposes, we only need to switch folders if we are not already in the correct folder,
  // because there's another function that loads the saved search.
  // But for insertable search, we need to force the sidepanel to open on every click handler.
  if (
    forceOpen ||
    currentSection !== NavConstants.Section.PROJECT_ITEMS ||
    currentListedFolder?.api_identifier !== folderFilter.value
  ) {
    try {
      const folder = await FolderDAO.fetch(folderFilter.value as string, {summary: '1'});
      if (!folder) {
        throw new Error('Folder not found');
      }

      getStore().dispatch(
        SidepanelReduxActions.listFolder(normalizeFolder(folder), {
          offset: 0,
          limit: getSelectedPageSize(),
          ...searchParams,
        })
      );
    } catch (e) {
      notifications.error(
        'Could not find project or folder for saved search. It may not exist or you may not have access'
      );
      throw e;
    }
  }
}
